import { useFetchQuery, ServicePath, buildApiUrl } from "@opengov/bnp-core";

export type FormRequestType = {
  id: string;
  name: string;
  status: "draft" | "published" | "archived";
};

const WORKFLOWS_MANAGING_APPLICATION_ID = "urn:opengov:application:workflows";

type GetFormRequestTypesResponse = {
  formTemplates: FormRequestType[];
};

export const useGetFormRequestTypes = ({ entityUuid }: { entityUuid: string | undefined }) => {
  return useFetchQuery<GetFormRequestTypesResponse>({
    url: buildApiUrl(
      `${ServicePath.FormServiceV1}/form_templates?entity_id=${entityUuid}&managing_application=${WORKFLOWS_MANAGING_APPLICATION_ID}`,
    ),
    queryKey: [
      "formRequestTypes",
      `entityUuid: ${entityUuid}`,
      `managingApplication: ${WORKFLOWS_MANAGING_APPLICATION_ID}`,
    ] as const,
    options: {
      enabled: Boolean(entityUuid),
    },
  });
};
